module.exports = __webpack_public_path__ + "media/images/athletes/1887-79b532f9995dcc7bb6c57a2d8fdb496b.png";